export const isLocal = import.meta.env.DEV
/* DTAP (OTAP); Denotes the common application environments. */
export const isDevelopment = import.meta.env.MODE === 'development'
export const isTest = import.meta.env.MODE === 'test'
export const isAcceptance = import.meta.env.MODE === 'acceptance'
export const isProduction = import.meta.env.MODE === 'production'
